<mat-toolbar class="main_header" *ngIf="currentUser">
  <mat-toolbar class="inner_header">
    <span
      ><a href=""
        ><img src="app/assets/images/stinelogo.png" alt="stine-logo" /></a
    ></span>

    <label
      class="text-[2.2rem] mb-[1px] font-extrabold font-stretch-ultra-condensed sales-header ml-1 mr-6 tracking-tighter"
      >SALES</label
    >

    <div class="menu_bar" *ngIf="!smallScreenSize" id="menu_Toggle_bar">
      <ng-container *ngFor="let topNavRoute of topNavRoutes">
        @if (!topNavRoute.children) {
          <a
            mat-button
            [routerLink]="topNavRoute.route"
            routerLinkActive="active-menu-list"
            >{{ topNavRoute.title }}
          </a>
        } @else {
          <a
            mat-button
            [matMenuTriggerFor]="menu"
            routerLinkActive="active-menu-list"
            >{{ topNavRoute.title }}
            <mat-icon matBadgeColor="warn">expand_more</mat-icon>
            <mat-menu #menu="matMenu">
              <div class="profile_bar">
                <div
                  *ngFor="let child of topNavRoute.children; let isLast = last"
                  [ngClass]="{
                    '!border-b !border-slate-400': !isLast,
                  }"
                >
                  <ng-container>
                    <a
                      mat-menu-item
                      [routerLink]="!isDisabled(child) ? child.route : null"
                      [disabled]="isDisabled(child)"
                    >
                      @if (child.icon) {
                        <mat-icon class="{{ child?.class }}">{{
                          child.icon
                        }}</mat-icon>
                      }
                      <span class="font-bold">{{ child.title }}</span>
                    </a>
                  </ng-container>
                </div>
              </div>
            </mat-menu>
          </a>
        }
      </ng-container>
    </div>
  </mat-toolbar>

  <div class="search_main">
    <div class="crop_year_select" [ngClass]="smallScreenSize ? 'mr-4' : ''">
      <mat-form-field appearance="outline" class="custom-mat-select-field" *ngIf="!isCompanyYearLoading">
        <mat-select
          [compareWith]="yearComparer"
          [formControl]="companyYearFormControl"
          class="custom_mat_select"
          disableRipple
        >
          <div class="cy-option">
            <mat-option
              *ngFor="let companyYear of companyYearService.data$ | async"
              [value]="companyYear"
            >
              {{ companyYear.year }}
            </mat-option>
          </div>
        </mat-select>
      </mat-form-field>

      <div class="loading-container" *ngIf="isCompanyYearLoading">
        <div class="green-spinner"></div>
      </div>
    </div>

    <div class="profile_box ml-1">
      <button
        class="profile_btn d-block"
        mat-button
        [matMenuTriggerFor]="menuProfile"
      >
        <div class="profile-img">
          <a class="avatar"
            ><span>{{ avatarText }}</span></a
          >
          <!-- <button
                        mat-icon-button
                        class="expand_more"
                        id="profile-expand"
                    > -->
          <mat-icon matBadgeColor="warn">expand_more</mat-icon>
          <!-- </button> -->
        </div>

        <mat-menu #menuProfile="matMenu">
          <div class="profile_bar">
            <div mat-menu-item disabled>
              <span>
                {{ currentUser.person.name }}
              </span>
              <mat-icon>person</mat-icon>
            </div>
             <div mat-menu-item disabled>
              <span>
                {{ roleText }}
              </span>
              <mat-icon>badge</mat-icon>
            </div>
            <mat-divider></mat-divider>

            <!-- <button (click)="onChangePassword()" mat-menu-item>
              <mat-icon>password</mat-icon>
              <span> Change Password </span>
            </button> -->

            <button (click)="logout(); menuTrigger?.closeMenu()" mat-menu-item>
              <mat-icon> exit_to_app</mat-icon>
              <span> Logout </span>
            </button>
          </div>
        </mat-menu>
      </button>

      <button
        (click)="toggleSidenav.emit(); toggleStineMenu.emit()"
        mat-icon-button
        class="menu_btn"
        aria-label="Menu icon-button"
      >
        <mat-icon>menu</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>
<div tabindex="-1" #dummyElement></div>
